/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyOutStatus
 */
export interface PropertyOutStatus {
    /**
     * 
     * @type {string}
     * @memberof PropertyOutStatus
     */
    statusCode: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyOutStatus
     */
    propertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyOutStatus
     */
    modificationDate: Date;
}

export function PropertyOutStatusFromJSON(json: any): PropertyOutStatus {
    return PropertyOutStatusFromJSONTyped(json, false);
}

export function PropertyOutStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyOutStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusCode': json['statusCode'],
        'propertyId': json['propertyId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function PropertyOutStatusToJSON(value?: PropertyOutStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusCode': value.statusCode,
        'propertyId': value.propertyId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


